export default {
  notFound: "Not Found",
  goHome: "Go Back",
};
